exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-select[data-v-72ec14e9] {\n  width: 1.145833rem;\n}\n.input-with-select[data-v-72ec14e9]  .el-input .el-input__inner {\n  height: 30PX !important;\n  line-height: 30PX;\n}", ""]);

// exports
